import { Navigate } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { useState, useEffect } from 'react';
import { initializeFirebase, getFirebaseInstance } from '../firebase/config';

function PrivateRoute({ children }) {
    const [authChecked, setAuthChecked] = useState(false);
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    useEffect(() => {
        let unsubscribe = () => { };

        const checkAuth = async () => {
            try {
                const { auth } = await initializeFirebase();

                unsubscribe = onAuthStateChanged(auth, (user) => {
                    console.log('Estado de autenticación:', user ? 'Autenticado' : 'No autenticado');
                    setIsAuthenticated(!!user);
                    setAuthChecked(true);
                });
            } catch (error) {
                console.error('Error al verificar autenticación:', error);
                setAuthChecked(true);
                setIsAuthenticated(false);
            }
        };

        checkAuth();
        return () => unsubscribe();
    }, []);

    if (!authChecked) {
        return (
            <div className="loading-container">
                <div>Verificando autenticación...</div>
            </div>
        );
    }

    if (!isAuthenticated) {
        console.log('Usuario no autenticado, redirigiendo a login');
        return <Navigate to="/login" replace />;
    }

    return children;
}

export default PrivateRoute; 